import classNames from 'classnames';
import { ModuleArrLoad } from 'layout/module-load/module-load-arr.js';
import { ModulesLazyLoadWrapper } from 'layout/module-load/modules-lazy-load-wrapper.js';
import { getModulesMetaData } from 'layout/module-load/modules-meta-data.js';
import { IPrimarySlotPropsMap } from 'redux-state/layout/types.layout.js';
import { ModulePath } from 'utilities/modulePath/modulePath.js';
import { hasModules } from './five-up-utils.js';
import { RenderSideModule } from './sideModule.js';

export const RenderSmallLayout = ({ filteredPrimaryConfig }: { filteredPrimaryConfig: IPrimarySlotPropsMap }) => {
  const { leftMajor, leftMinor, rightMajor, rightMinor, main } = filteredPrimaryConfig;
  const hasLeftMajor = hasModules(leftMajor);
  const hasLeftMinor = hasModules(leftMinor);
  const hasRightMajor = hasModules(rightMajor);
  const hasRightMinor = hasModules(rightMinor);
  const hasMain = hasModules(main);

  const leftMinorClass = classNames('u-mB-responsive', { 'u-mT-responsive': hasLeftMajor || hasMain });

  return (
    <div className="Grid-cell">
      {hasLeftMajor && (
        <ModulesLazyLoadWrapper
          section={getModulesMetaData('five-up-sm-leftMajor', leftMajor.modules)}
          className="u-mB-responsive"
        >
          <ModuleArrLoad modules={leftMajor.modules} modulePath={ModulePath.PRIMARY_LEFT_MAJOR} />
        </ModulesLazyLoadWrapper>
      )}
      {hasMain && (
        <ModulesLazyLoadWrapper
          section={getModulesMetaData('five-up-sm-main', main.modules)}
          className={classNames({ 'u-mB-responsive': hasLeftMinor || hasRightMajor || hasRightMinor })}
        >
          <ModuleArrLoad modules={main.modules} modulePath={ModulePath.PRIMARY_MAIN} />
        </ModulesLazyLoadWrapper>
      )}
      {hasLeftMinor && (
        <ModulesLazyLoadWrapper
          section={getModulesMetaData('five-up-sm-leftMinor', leftMinor.modules)}
          className={leftMinorClass}
        >
          <ModuleArrLoad modules={leftMinor.modules} modulePath={ModulePath.PRIMARY_LEFT_MINOR} />
        </ModulesLazyLoadWrapper>
      )}
      <RenderSideModule rightMajor={rightMajor} rightMinor={rightMinor} />
    </div>
  );
};
